module.exports = __webpack_public_path__ + "static/media/galeria-fotos-5.c2e06901.png";